export const consumptionAmendmentSchema = {
  title: 'Consumption Amendment',
  type: 'object',
  properties: {
    mpan_core: {
      type: 'string',
      title: 'MPAN Core',
    },
    supplier_reference: {
      type: 'string',
      title: 'Supplier Reference',
      maxLength: 50,
    },
    period_start_date: {
      type: 'string',
      format: 'date-time',
      title: 'Period Start Date',
    },
    period_end_date: {
      type: 'string',
      format: 'date-time',
      title: 'Period End Date',
    },
    measurement_quantity_id: {
      type: 'string',
      title: 'Measurement Quantity ID',
      enum: ['AI', 'AE', 'RI', 'RE'],
      enumNames: ['AI - Active Import', 'AE - Active Export', 'RI - Reactive Import', 'RE - Reactive Export'],
    },
    gross_revised_consumption: {
      type: 'number',
      title: 'Gross Revised Consumption (kWh/kVAR)',
    },
    reason_code: {
      type: 'string',
      title: 'Reason Code',
      enum: ['A', 'E', 'M', 'R', 'S', 'T', 'X'],
      enumNames: [
        'A - Agreed Read',
        'E - Estimation Issue',
        'M - Metering Issue (Crossed/Missed Exchange/Found)',
        'R - Reading Issue (Transposed / Misread)',
        'S - Stolen/Lost Meter',
        'T - Tampering/Theft',
        'X - Other',
      ],
    },
  },
  required: [
    'mpan_core',
    'period_start_date',
    'period_end_date',
    'measurement_quantity_id',
    'gross_revised_consumption',
    'reason_code',
  ],
};

export const consumptionAmendmentUISchema = {
  mpan_core: {
    'ui:placeholder': 'Select MPAN',
  },
  supplier_reference: {
    'ui:placeholder': 'Optional supplier reference (max 50 characters)',
  },
  period_start_date: {
    'ui:widget': 'datetime',
    'ui:placeholder': 'Select period start date and time',
  },
  period_end_date: {
    'ui:widget': 'datetime',
    'ui:placeholder': 'Select period end date and time',
  },
  measurement_quantity_id: {
    'ui:placeholder': 'Select measurement quantity',
  },
  gross_revised_consumption: {
    'ui:placeholder': 'Enter consumption (e.g., 13.123)',
    'ui:help': 'Max 14 digits with exactly 3 decimal places',
  },
  reason_code: {
    'ui:placeholder': 'Select reason code',
  },
};
